module.exports = __webpack_public_path__ + "assets/img/BP-2.d83b6a51.jpg";